/*
===============================================================================================================
                                 Copyright 2022-2022, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

export const ALLOWED_CSV_FILE_TYPES = ['csv', 'text/csv', 'application/vnd.ms-excel'];

const validateFile = (fileData) => {
  if (!ALLOWED_CSV_FILE_TYPES.includes(fileData.type)) {
    return {
      valid: false,
      error: 'constants.invalidFileType',
    };
  }

  return {
    valid: true,
  };
};

export default validateFile;
